import { ProcessOneDataType } from 'QuoteApp/screens/Purchase';
import { LegacyPostFieldDataType, ProcessOneRequestDataType } from './types';

export const transformProcessOnePaymentTokenRequest = (
  data: ProcessOneRequestDataType
): LegacyPostFieldDataType => {
  return formatStepData(data.entityId, {
    paymentType: data.paymentType,
    cardHolderName: data.cardHolderName,
    lastFourDigits: data.lastFourDigits,
    tokenId: data.tokenId,
    holderZip: data.holderZip,
    cardType: data.cardType,
    cardExpirationMonth: data.cardExpirationMonth,
    cardExpirationYear: data.cardExpirationYear,
  });
};

const formatStepData = (
  entityId: string | null,
  data: ProcessOneDataType
): LegacyPostFieldDataType => {
  return {
    field_data: Object.entries(data).map(([key, value]) => ({
      entity_id: entityId,
      field_id: keyMap[key],
      value: value,
    })),
  };
};

const keyMap: Record<string, string> = {
  paymentType: 'payment_type',
  cardHolderName: 'card_holder_name',

  // ProcessOne values
  lastFourDigits: 'number_last_four',
  tokenId: 'one_inc_payment_token',
  holderZip: 'card_holder_zip',
  cardType: 'credit_card_type',
  cardExpirationMonth: 'card_expiration_month',
  cardExpirationYear: 'card_expiration_year',
};
